<div class="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat overflow-hidden font-sans" style="background-image: url('assets/images/bg-auth-4-compress.jpg');">
  <!-- Gradient Overlay (plus sombre pour faire ressortir la carte) -->
  <div class="absolute inset-0 bg-black/70 z-0"></div>
  
  <!-- Formes lumineuses décoratives -->
  <div class="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-yellow-400/30 blur-[120px] rounded-full animate-blob"></div>
  <div class="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] bg-orange-500/30 blur-[120px] rounded-full animate-blob animation-delay-2000"></div>

  <!-- Conteneur principal Solide -->
  <div class="relative z-10 w-full max-w-lg px-4 sm:px-0">
    <div class="bg-white shadow-2xl rounded-3xl overflow-hidden transform transition-all hover:shadow-[0_20px_50px_rgba(245,158,11,0.2)]">
      
      <!-- Barre d'accentuation supérieure -->
      <div class="h-1.5 w-full bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-500"></div>

      <div class="p-8 sm:p-12">
        <!-- Logo et Titre -->
        <div class="text-center mb-10">
          <img [src]="'/assets/images/LogoPrimeJaune.png'" class="w-32 sm:w-40 drop-shadow-sm mx-auto mb-4" alt="Logo Prime Store" />
          <p class="text-gray-500 font-medium tracking-wide mt-2">Accès Espace Administrateur</p>
        </div>

        <!-- Zone d'erreur -->
        <div *ngIf="loginError()" class="mb-6 p-4 rounded-xl bg-red-50 border border-red-200 flex items-center gap-3 animate-fade-in-down">
          <svg class="w-6 h-6 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <p class="text-sm text-red-700 font-medium">{{ loginError() }}</p>
        </div>

        <!-- Formulaire -->
        <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="space-y-6">
          
          <!-- Email Input -->
          <div class="relative group">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400 group-focus-within:text-yellow-500 transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
              </svg>
            </div>
            <input 
              type="email" 
              formControlName="login"
              class="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/50 focus:border-yellow-400 focus:bg-white transition-all duration-300"
              placeholder="Adresse email"
            >
          </div>

          <!-- Password Input -->
          <div class="relative group">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400 group-focus-within:text-yellow-500 transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <input 
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              class="block w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/50 focus:border-yellow-400 focus:bg-white transition-all duration-300"
              placeholder="Mot de passe"
            >
            <button 
              type="button"
              (click)="googlePassword()"
              class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-yellow-500 focus:outline-none transition-colors"
            >
              <svg *ngIf="!showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg *ngIf="showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m9.02 9.02l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>

          <!-- Options Supplémentaires -->
          <div class="flex items-center justify-between mt-2">
            <label class="flex items-center space-x-2 cursor-pointer group">
              <div class="relative flex items-center justify-center w-5 h-5">
                <input type="checkbox" formControlName="rememberMe" class="peer sr-only">
                <div class="w-5 h-5 bg-white border border-gray-300 rounded peer-checked:bg-yellow-500 peer-checked:border-yellow-500 transition-all duration-200"></div>
                <svg class="absolute w-3 h-3 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
                </svg>
              </div>
              <span class="text-sm text-gray-600 group-hover:text-gray-900 transition-colors">Se souvenir de moi</span>
            </label>
            
            <a href="#" class="text-sm font-medium text-yellow-600 hover:text-yellow-500 transition-colors">Mot de passe oublié ?</a>
          </div>

          <!-- Bouton Submit -->
          <button 
            type="submit"
            [disabled]="loginForm.invalid || loading() || isLockedOut"
            class="relative w-full py-4 mt-6 rounded-xl font-bold text-white overflow-hidden group transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            [ngClass]="{'bg-gradient-to-r from-yellow-500 to-orange-500 shadow-lg hover:shadow-xl': !loginForm.invalid && !loading() && !isLockedOut, 'bg-gray-300 text-gray-500': loginForm.invalid || loading() || isLockedOut}"
          >
            <div *ngIf="!loginForm.invalid && !loading() && !isLockedOut" class="absolute inset-0 w-full h-full bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:animate-shimmer"></div>
            
            <span class="relative flex items-center justify-center gap-2">
              <span *ngIf="!loading()">Connexion Sécurisée</span>
              <span *ngIf="loading()" class="flex items-center gap-2">
                <svg class="w-5 h-5 animate-spin text-white" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Authentification...
              </span>
              <svg *ngIf="!loading()" class="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </span>
          </button>

        </form>
      </div>
    </div>
    
    <!-- Pied de page discret -->
    <div class="mt-8 text-center text-sm text-gray-300">
      <p>© 2026 Prime Store. Tous droits réservés.</p>
    </div>
  </div>
</div>
